import React from 'react';
import _ from 'lodash';
import API from '../../../utils/network';
import env from '../../../utils/env';
import AlertBoxType, { AlertBoxActions } from '../../../@types/alertBox';
import { stringIsNumber, isNullOrUndefined, stringIsNullOrUndefinedOrBlank } from '../../../utils/siteFunctions';
import { initialState } from './reducer';
import { AxiosRequestConfig } from 'axios';
import appConfig from '../../../config';
import { PopupMessageButton } from '../../../@types/ui/ui';
// import { BLUE } from '../../../styles/colors';

export const actionTypes = {
	SET_USER: '/ss_project/ui/SET_USER',
	SET_CUSTOMER: '/ss_project/ui/SET_CUSTOMER',
	SET_CUSTOMER_PIN: '/ss_project/ui/SET_PIN',
	SET_CUSTOMER_NAME: '/ss_project/ui/SET_CUSTOMER_NAME',
	SET_CUSTOMER_PRIMARY_COLOR: '/ss_project/ui/SET_PRIMARY_COLOR',
	SET_CUSTOMER_SECONDARY_COLOR: '/ss_project/ui/SET_SECONDARY_COLOR',
	SET_CUSTOMER_LOGO_URL: '/ss_project/ui/SET_LOGO_URL',
	RESET_CUSTOMER: '/ss_project/ui/RESET_CUSTOMER',
	// REFRESH_CUSTOMER_CLIENT_PORTAL_SETTINGS: '/ss_project/ui/REFRESH_CUSTOMER_CLIENT_PORTAL_SETTINGS',
	SET_INITIAL_CHECK_FOR_AUTHENTICATION_COMPLETED: '/ss_project/ui/SET_INITIAL_CHECK_FOR_AUTHENTICATION_COMPLETED',
	SET_CLIENT: '/ss_project/ui/SET_CLIENT',
	ADD_POPUP_MESSAGE: '/ss_project/ui/ADD_POPUP_MESSAGE',
	REMOVE_SHOWN_POPUP_MESSAGE: '/ss_project/ui/REMOVE_SHOWN_POPUP_MESSAGE'
	// GET_CLIENT: '/ss_project/ui/GET_CLIENT'
	// SET_WINDOW_DIMENSIONS       : '/ss_project/ui/SET_WINDOW_DIMENSIONS',
	// SET_SCROLL_PERCENT          : '/ss_project/ui/SET_SCROLL_PERCENT',
	// TOGGLE_SIDE_NAV             : '/ss_project/ui/TOGGLE_SIDE_NAV',
	// SET_SIDE_NAV_ROUTES         : '/ss_project/ui/SET_SIDE_NAV_ROUTES',
	// SHOW_ALERT_BOX              : '/ss_project/ui/SHOW_ALERT_BOX',
	// HIDE_ALERT_BOX              : '/ss_project/ui/HIDE_ALERT_BOX',
	// SHOW_ERROR_MESSAGE          : '/ss_project/ui/SHOW_ERROR_MESSAGE',
	// START_SPINNER               : '/ss_project/ui/START_SPINNER',
	// STOP_SPINNER                : '/ss_project/ui/STOP_SPINNER',
	// DISABLE_BUTTON              : '/ss_project/ui/DISABLE_BUTTON',
	// ENABLE_BUTTON               : '/ss_project/ui/ENABLE_BUTTON',
	// UNSUPPORTED_BROWSER_BANNER  : '/ss_project/ui/UNSUPPORTED_BROWSER_BANNER',
};

///////////////////////////////////////////
//        local calls
///////////////////////////////////////////
export const setUser = user => dispatch => {
	dispatch({
		type: actionTypes.SET_USER,
		user: user
	});

	return Promise.resolve();
};

export const setCustomer = customer => dispatch => {
	dispatch({
		type: actionTypes.SET_CUSTOMER,
		customer: customer
	});

	return Promise.resolve();
};

export const setCustomerPin = pin => ({
	type: actionTypes.SET_CUSTOMER_PIN,
	pin: pin
});

export const setCustomerName = name => ({
	type: actionTypes.SET_CUSTOMER_NAME,
	name: name
});

export const setCustomerPrimaryColor = color => dispatch => {
	dispatch({
		type: actionTypes.SET_CUSTOMER_PRIMARY_COLOR,
		color: color
	});

	return Promise.resolve();
};

export const setCustomerSecondaryColor = color => ({
	type: actionTypes.SET_CUSTOMER_SECONDARY_COLOR,
	color: color
});

export const setCustomerLogoUrl = url => ({
	type: actionTypes.SET_CUSTOMER_LOGO_URL,
	url: url
});

export const resetCustomer = () => ({
	type: actionTypes.RESET_CUSTOMER
});

export const setInitialCheckForAuthenticationCompleted = initialCheckForAuthenticationCompleted => dispatch => {
	dispatch({
		type: actionTypes.SET_INITIAL_CHECK_FOR_AUTHENTICATION_COMPLETED,
		initialCheckForAuthenticationCompleted: initialCheckForAuthenticationCompleted
	});

	return Promise.resolve();
};

export const setClient = client => dispatch => {
	dispatch({
		type: actionTypes.SET_CLIENT,
		client: client
	});

	return Promise.resolve();
};

export const addPopupMessage = (message: string | React.ReactNode, title: string | undefined = undefined, icon: string | undefined = undefined, buttons: PopupMessageButton[] = [ { text: 'OK', secondary: true } ]) => dispatch => {
	dispatch({
		type: actionTypes.ADD_POPUP_MESSAGE,
		popupMessage: {
			message: message,
			title: title,
			icon: icon,
			buttons: buttons
		}
	});

	return Promise.resolve();
};

export const removeShownPopupMessage = () => dispatch => {
	dispatch({
		type: actionTypes.REMOVE_SHOWN_POPUP_MESSAGE
	});

	return Promise.resolve();
};

// export const setWindowDimensions = () => ({
// 	type: actionTypes.SET_WINDOW_DIMENSIONS,
// 	height: window.innerHeight,
// 	width: window.innerWidth,
// });

// export const setScrollPercent = percent => ({
// 	type: actionTypes.SET_SCROLL_PERCENT,
// 	percent
// });

// export const toggleSideNav = (isOpen: boolean) => ({
// 	type: actionTypes.TOGGLE_SIDE_NAV,
// 	isOpen
// });

// export const showReleaseNotes = () => (
// 	(dispatch, getState) => {
// 		const { ui } = getState();

// 		dispatch(showAlertBox({
// 			title: 'Release Notes',
// 			message: (
// 				<iframe
// 					title="admin-version"
// 					width={ui.width - 50}
// 					height={ui.height - 150}
// 					src={env('REACT_APP_VERSION_URL')}
// 				></iframe>
// 			),
// 			actions: {
// 				Ok: {
// 					color: BLUE,
// 					styles: { marginRight: '100px' },
// 					onClick: () => {
// 						dispatch(hideAlertBox());
// 						localStorage.setItem('ucrInfo', JSON.stringify({ versionNumber: env('REACT_APP_ADMIN_VERSION') }));
// 					}
// 				}
// 			},
// 			fullScreen: true,
// 		}));
// 	}
// );

// export const checkReleaseNotes = () => {
// 	const versionNumber = env('REACT_APP_VERSION');
// 	// @ts-ignore
// 	const ucrStorageInfo = JSON.parse(localStorage.getItem('ucrInfo'));
// 	if (ucrStorageInfo === null || versionNumber !== ucrStorageInfo.versionNumber) {
// 		showReleaseNotes();
// 	}
// };

// export const setSideNavRoutes = routes => ({
// 	type: actionTypes.SET_SIDE_NAV_ROUTES,
// 	routes
// });

// export const showAlertBox = ({ title, reason, message, actions, disableBackdropClick, fullScreen }: AlertBoxType) => ({
// 	type: actionTypes.SHOW_ALERT_BOX,
// 	title,
// 	reason,
// 	message,
// 	actions,
// 	disableBackdropClick,
// 	fullScreen,
// });

// export const hideAlertBox = () => ({
// 	type: actionTypes.HIDE_ALERT_BOX
// });

// export const showErrorMessage = (error: any, actions: AlertBoxActions) => ({
// 	type: actionTypes.SHOW_ERROR_MESSAGE, // TODO: don't show this if the error message is "Request Aborted"
// 	error,
// 	actions,
// });

// export const startSpinner = () => ({
// 	type: actionTypes.START_SPINNER,
// });

// export const stopSpinner = () => ({
// 	type: actionTypes.STOP_SPINNER,
// });

// export const disableButton = () => ({
// 	type: actionTypes.DISABLE_BUTTON
// });

// export const enableButton = () => ({
// 	type: actionTypes.ENABLE_BUTTON
// });

// export const browserCheck = () =>
// 	dispatch => {
// 		dispatch({ type: actionTypes.UNSUPPORTED_BROWSER_BANNER, isShowing: false });
// 		const supportedBrowser = !!(
// 		// desktop browsers
// 			navigator.userAgent.match(/Chrome/i) ||
//       navigator.userAgent.match(/Safari/i) ||
//       navigator.userAgent.match(/Firefox/i) ||
//       navigator.userAgent.match(/Edge/i)
// 		);

// 		const unsupportedBrowser = !!(
// 			navigator.userAgent.match(/Trident/i) // IE
// 		);

// 		if (unsupportedBrowser) {
// 			dispatch(unsupportedBrowserAlert());
// 			dispatch({ type: actionTypes.UNSUPPORTED_BROWSER_BANNER, isShowing: true });

// 		} else if (!supportedBrowser) {
// 			dispatch(browserSuggestionAlert());
// 		}
// 	};

///////////////////////////////////////////
//        API calls
///////////////////////////////////////////
// export const exampleAPICALL = () => (
// 	dispatch =>
// 		API({
// 			method: 'POST',
// 			url: 'example/url/here',
// 		})
// 			.then(response => {
// 				console.log(response);
// 			})
// 			.catch(error => dispatch(showErrorMessage(error, { Ok: { onClick: () => {
// 				dispatch(hideAlertBox());
// 			} }})))
// );

export const refreshCustomerClientPortalSettings = (pin?: number) => dispatch => {
	if (pin !== undefined && pin !== null) {
		return API.get('settings/client-portal/customer/' + pin.toString())
			.then(data => {
				return dispatch(setCustomer({
					pin: pin,
					customerName: data.data.name,
					primaryColor: data.data.primaryColor,
					secondaryColor: data.data.secondaryColor,
					logoUrl: stringIsNullOrUndefinedOrBlank(data.data.logoPath) ? initialState.customer.logoUrl : `${appConfig.webAppUrl}/${data.data.logoPath}`
				}));
			})
			.catch(error => console.error('Error', error));
	}
	else {
		return dispatch(resetCustomer());
	}

	return Promise.resolve();
};

export const getClient = () => dispatch => {
	return API.get('/client/get')
		.then(data => {
			return dispatch(setClient({
				name: data.data.name,
				fullName: stringIsNullOrUndefinedOrBlank(data.data.fullName) ? null : data.data.fullName,
				permissions: {
					EditCollectionStatus: data.data.portalPermissions.editCollectionStatus,
					ShowReminders: data.data.portalPermissions.showReminders,
					AddAccountsManually: data.data.portalPermissions.addAccountsManually,
					UploadDocuments: data.data.portalPermissions.uploadDocuments,
					UploadBulkAccountFiles: data.data.portalPermissions.uploadBulkAccountFiles,
					UploadClientDocuments: data.data.portalPermissions.uploadClientDocuments,
					SearchForAccounts: data.data.portalPermissions.searchForAccounts,
					EnterOwnInterestRates: data.data.portalPermissions.enterOwnInterestRates,
					AddPayments: data.data.portalPermissions.addPayments,
					AllowCustomPaymentDates: data.data.portalPermissions.allowCustomPaymentDates,
					WarnWhenEnteringMinor: data.data.portalPermissions.warnWhenEnteringMinor
				},
				showFieldsSettings: {
					DateOfFirstDelinquency: data.data.showFieldsSettings.dateOfFirstDelinquency,
					OriginatedDate: data.data.showFieldsSettings.originatedDate,
					DebtorNotes: data.data.showFieldsSettings.debtorNotes,
					AccountNotes: data.data.showFieldsSettings.accountNotes,
					CallNotes: data.data.showFieldsSettings.callNotes,
					DebtorEmployer: data.data.showFieldsSettings.debtorEmployer,
					DocNotes: data.data.showFieldsSettings.docNotes,
					InterestStartDate: data.data.showFieldsSettings.interestStartDate,
					InterestRate: data.data.showFieldsSettings.interestRate,
					ClaimNote: data.data.showFieldsSettings.claimNote,
					DebtorPhone: data.data.showFieldsSettings.debtorPhone,
					DebtorEmail: data.data.showFieldsSettings.debtorEmail,
					AllocationsAndDisbursements: data.data.showFieldsSettings.allocationsAndDisbursements,
					TotalCosts: data.data.showFieldsSettings.totalCosts,
					TotalInterest: data.data.showFieldsSettings.totalInterest,
					AccountType: data.data.showFieldsSettings.accountType,
					UploadNote: data.data.showFieldsSettings.uploadNote
				}
			}));
		})
		.catch(error => console.error('Error', error));
};

///////////////////////////////////////////
//            Helper functions
///////////////////////////////////////////
// const unsupportedBrowserAlert = () =>
// 	dispatch =>
// 		dispatch(showAlertBox({
// 			title: 'Unsupported Browser Detected',
// 			message: <div>
// 				<p>We currently do not support your browser!</p>
// 				<div>Reasons:</div>
// 				<ul>
// 					<li>Browser is too old</li>
// 					<li>Security Concerns</li>
// 					<li>Browser is no longer supported by the creator company (e.g. Microsoft, Apple, Google)</li>
// 				</ul>
// 				<p>Please use a modern browser (e.g. latest versions of Chrome, Firefox, Safari, Edge).</p>
// 			</div>,
// 			actions: {
// 				Ok: {
// 					color: BLUE,
// 					onClick: () => dispatch(hideAlertBox())
// 				}
// 			},
// 		}));

// const browserSuggestionAlert = () =>
// 	dispatch =>
// 		dispatch(showAlertBox({
// 			title: 'Browser Warning',
// 			message: <div>
// 				<p>We notice you are using a browser that has known issues.</p>
// 				<p>We recommend using a different browser (e.g. latest versions of Chrome, Firefox, Safari, Edge).</p>
// 			</div>,
// 			actions: {
// 				Ok: {
// 					color: BLUE,
// 					onClick: () => dispatch(hideAlertBox())
// 				}
// 			},
// 		}));